import { toCatchupFilter } from "./ToCatchupFilter";

export function hockeyPossessionCatchup(messages, currentState, updateState) {
  let tempEntities = currentState.entities;

  if (!tempEntities?.length) {
    return;
  }

  const relevantEvents = toCatchupFilter(messages, currentState).filter((msg) =>
    ["possession", "centrePass", "goal", "penaltyStroke"].includes(msg.eventType),
  );

  if (!relevantEvents.length) {
    return;
  }

  const lastEvent = relevantEvents[relevantEvents.length - 1];

  if (lastEvent.eventType === "goal" || (lastEvent.eventType === "penaltyStroke" && lastEvent.subType === "made")) {
    updateState("posTracking", null);
  } else if (lastEvent.eventType === "possession" || lastEvent.eventType === "centrePass") {
    const possessionEntity = tempEntities.find((team) => team.entityId === lastEvent.entityId);
    if (!possessionEntity) {
      return;
    }
    const position =
      lastEvent.subType === null || typeof lastEvent.subType === "undefined" || lastEvent.eventType === "centrePass"
        ? "defensive"
        : lastEvent.subType;

    updateState("posTracking", { type: position, entity: possessionEntity });
  }
}
